import { DatePipe } from '@angular/common';
import { Component, Output, type OnInit, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-birthdate-input',
    templateUrl: './birthdate-input.component.html',
    styleUrls: ['./birthdate-input.component.scss'],
    providers: [
        provideMomentDateAdapter({
          parse: {
            dateInput: 'DD/MM/yyyy',
          },
          display: {
            dateInput: 'DD/MM/yyyy',
            monthYearLabel: 'MMMM YYYY',
            dateA11yLabel: 'DD/MM/yyyy',
            monthYearA11yLabel: 'MMMM yyyy',
          }
        }),
        { provide: MAT_DATE_LOCALE, useValue: 'fr' },
      ]
})
export class BirthdateInputComponent implements OnInit, OnDestroy {
    @Output() birthdateChange = new EventEmitter<string>();
    birthdate = new FormControl('', Validators.required);
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    maxDate: Date = new Date();

    constructor(
        public adapter: DateAdapter<any>,
        private datePipe: DatePipe
    ) {
        this.adapter.setLocale('fr');
    }

    ngOnInit(): void {
        this.birthdate.valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                () => this.onDateChange()
            )
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    onDateChange(): void {
        this.birthdate.setValue(this.datePipe.transform(this.birthdate.value, 'yyyy-MM-dd'), { emitEvent: false });
        this.birthdateChange.emit(this.birthdate.value);
    }

    disableInput() {
        this.birthdate.disable();
    }
    
    enableInput() {
        this.birthdate.enable();
    }
}
